import { render, staticRenderFns } from "./dispose.vue?vue&type=template&id=928cfd5a"
import script from "./dispose.vue?vue&type=script&lang=js"
export * from "./dispose.vue?vue&type=script&lang=js"
import style0 from "./dispose.vue?vue&type=style&index=0&id=928cfd5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports